import Rule from "../../../../common/rule";
import DriveEndType from "../../../enums/drive-end-type";

//In this case we only need to check the play for any penalties, that would prevent normal changing of downs

export default class ChangeDown extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            !gameContext.triggerPAT &&
            !ruleContext.PAT &&
            ruleContext.advanceDown &&
            !ruleContext.changeDownApplied
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        ruleContext.setChangeDownApplied(true);

        gameContext.down++;

        if (
            gameContext.down > gameContext.gameConfig.general.downs &&
            !ruleContext.awardFirstDown
        ) {
            gameContext.switchPossession();
            ruleContext.setAwardFirstDown(true);
            gameContext.setDriveContext({
                triggerDrive: true,
                previousDriveEndType: DriveEndType.TurnoverOnDowns
            });
        }
    }
}
